module.exports = __webpack_public_path__ + "img/user.ca125849.svg";